
// src/web/routes

import React from 'react'
import { Route, IndexRedirect } from 'react-router'

import App from './components/app.jsx'
import LoginPage from './components/login-page.jsx'
import MainPage from './components/main-page.jsx'
import GroupsPage from './components/groups-page.jsx'
import GroupTimelinePage from './components/group-timeline-page.jsx'
import HomeGroupsPage from './components/home-groups-page.jsx'
import DivisionGroupsPage from './components/division-groups-page.jsx'
import DivisionNotSetGroupsPage from './components/division-not-set-groups-page.jsx'
import UnavailablePage from './components/unavailable-page.jsx'
import PickupDiariesPage from './components/pickup-diaries-page.jsx'
import ChatMessagesPage from './components/chat-messages-page.jsx'

export default (
  <Route component={App}>
    <Route component={LoginPage} path="/login" name="login"/>
    <Route component={MainPage} path="/" name="main">
      <Route component={HomeGroupsPage} path="/groups/home" name="home_group">
        <Route component={PickupDiariesPage} path="/groups/home/pickup" name="home_pickup" />
        <Route component={ChatMessagesPage} path="/groups/home/messages/:chat_room_id" name="chat_messages" />
      </Route>
      <Route component={GroupsPage} path="/groups/:group_id" name="group">
        <Route component={GroupTimelinePage} path="timeline" name="group_timeline">
          <Route component={PickupDiariesPage} path="pickup" name="group_pickup" />
        </Route>
        <IndexRedirect to="timeline" />
      </Route>
      <Route component={DivisionGroupsPage} path="/section/:division_id" name="division_group" />
      <Route component={DivisionNotSetGroupsPage} path="/section-new/:division_id" name="division_not_set_group" />
    </Route>
    <Route component={UnavailablePage} path="/unavailable" name="unavailable" />
  </Route>
)



// WEBPACK FOOTER //
// ./src/web/routes.js